import { render, staticRenderFns } from "./ConfirmEmailAddrress.vue?vue&type=template&id=61ba4ccf&scoped=true&"
import script from "./ConfirmEmailAddrress.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmailAddrress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba4ccf",
  null
  
)

export default component.exports